import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const AssignedFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M12 10.7A3.85 3.85 0 1 0 12 3a3.85 3.85 0 0 0 0 7.7Z"
        fill={color}
      />
      <Path
        d="m11.9 17.88 2.33 2.33 5.87-5.86"
        stroke={color ? color : '#000'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10.49 19.29c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0l.91.91 4.31-4.31c-1.32-1.19-3.05-1.93-4.96-1.93H10.4c-4.08 0-7.41 3.33-7.41 7.41v1.45h8.21l-.7-.7h-.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default AssignedFilled
